<template>
  <div>    
    <Courses/>
  </div>
</template>

<script>
import Courses from "@/views/Courses";

export default {
  name: "home",
  data: () => ({}),
  computed: {},
  components: {
    Courses
  }
};
</script>
